<template>
  <el-dialog
    :title="translateTo('设备位置')"
    class="h-coords-dialog"
    :visible="true"
    :append-to-body="true"
    width="70%"
    top="5vh"
    cust
    :before-close="handleBeforeClose"
  >
    <div class="h-coords-dialog_content" v-loading="loading">
      <Bmap
        ref="bmap"
        :has-search="false"
        :has-theme-switcher="false"
        :initPoint="initPoint"
        @loaded="mapLoaded"
        @mapHandler="mapHandler"
      />
    </div>
  </el-dialog>
</template>

<script>
import Bmap from '@/components/bmap';
import { stateMapMarker as smm } from '@/utils/dict';
import { mapState } from 'vuex';
import { isEmpty } from '@/utils/is';

export default {
  name: 'SetPositionMap',
  components: { Bmap },
  props: {
    coords: {
      type: Object,
      default: () => ({
        longitude: 0,
        latitude: 0
      })
    },
    useRealTime: {
      type: Boolean,
      default: false
    },
    sn: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    container: {
      type: [HTMLElement],
      default: () => document.body
    }
  },
  data() {
    return {
      initPoint: {},
      loading: true
    };
  },
  computed: {
    ...mapState('socket', ['deviceSNMap'])
  },
  methods: {
    handleBeforeClose(done) {
      this.$destroy();
      done();
    },
    mapLoaded({ bmap }) {
      this.loading = false;
      const { coords, useRealTime, sn, name } = this;

      const pos = [];

      if (useRealTime) {
        const deviceInfo = this.deviceSNMap[sn];

        if (!isEmpty(deviceInfo)) pos.push(deviceInfo.longitude, deviceInfo.latitude);
      }

      if (isEmpty(this.initPoint)) {
        pos.push(coords.longitude, coords.latitude);
      }

      this.initPoint = new BMap.Point(...pos);

      bmap.centerAndZoom(this.initPoint, 11);

      /*********marker */
      this.marker = new BMap.Marker(new BMap.Point(...pos), {
        icon: new BMap.Icon(smm[0], new BMap.Size(32, 32)),
        offset: new BMap.Size(0, -16)
      });

      bmap.addOverlay(this.marker);

      /*********label */
      if (name || sn) {
        this.label = new BMap.Label(name || sn, {
          position: new BMap.Point(...pos),
          offset: new BMap.Size(0, -55)
        });

        this.label.setStyle({
          fontSize: '14px',
          border: '2px solid #1E90FF',
          transform: 'translateX(-50%)',
          borderRadius: '5px',
          padding: '3px 8px'
        });

        bmap.addOverlay(this.label);
      }

      if (useRealTime) {
        this.unwatchPos = this.$watch(
          () => this.deviceSNMap[sn],
          newVal => {
            try {
              if (isEmpty(newVal)) return;

              const { longitude, latitude } = newVal;

              const { lng, lat } = this.marker.point;

              if (longitude === lng && latitude === lat) return;

              this.marker.setPosition(new BMap.Point(longitude, latitude));

              this.label?.setPosition(new BMap.Point(longitude, latitude));

              bmap.centerAndZoom(new BMap.Point(longitude, latitude), bmap.getZoom() || 11);
            } catch (error) {
              console.error('[更新位置失败]', error);
            }
          },
          {
            deep: true
          }
        );
      }

      // bmap.addEventListener('rightclick', ({ point }) => {
      //   marker.setPosition(point);
      //   label.setPosition(point);
      // });
    },
    mapHandler(theme) {
      this.$nextTick(() => {
        this.$refs.bmap.bmap.setMapStyleV2({ styleJson: theme });
      });
    }
  },
  mounted() {
    /** @type {HTMLElement} */
    const container = this.container;

    container.appendChild(this.$el);
  },
  beforeDestroy() {
    /** @type {HTMLElement} */
    const el = this.$el;

    el.parentNode.removeChild(el);

    this.unwatchPos?.();
  }
};
</script>

<style lang="scss">
.h-coords-dialog {
  &_content {
    height: 70vh;
  }
}
</style>
